import { inject, Injectable } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { minArrayCheckedLength } from '../validators/min-array-checked-length.validator';
import { SenderIdOpa, SenderIdsOpasFormArray } from '../interfaces/forms/sender-ids-opas-form.interface';

@Injectable({
  providedIn: 'root',
})
export class SenderIdsOpasFormService {
  public readonly fb = inject(FormBuilder);

  public formArray: SenderIdsOpasFormArray;

  public initFormArray(minLength = 1): SenderIdsOpasFormArray {
    this.formArray = this.fb.array<FormControl<SenderIdOpa>>([], { validators: [minArrayCheckedLength(minLength)] });
    return this.formArray;
  }

  public disableValidation() {
    this.formArray.clearValidators();
    this.formArray.updateValueAndValidity();
  }

  public enableValidation(minLength = 1) {
    this.formArray.setValidators(minArrayCheckedLength(minLength));
    this.formArray.updateValueAndValidity();
  }

  public reset() {
    this.formArray.controls.forEach(control => control.setValue({ selected: false, id: control.value.id }));
  }
}
